import * as styles from 'styles/pages/Styleguide.css'
import { Caption } from 'components/atoms/Text'
import Logo from 'components/features/pfm/Logo/Logo'

const SGLogos = () => (
  <section className={ styles.sgSection }>
    <Logo target='home' size='regular' />
    <Caption text='regular logo' />
  </section>
)

export default SGLogos
